var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticStyle: { display: "none" } }, [_vm._t("default")], 2),
    _c("div", [_vm._v("Pomyślnie wylogowano")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }